// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__DnPuI","productName":"Table_productName__3HbEz"};